module.exports = __webpack_public_path__ + "static/media/17.505ee17b.png";